/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { Product } from 'services/query-v2/products/index/product-info/model'
import { DailyStatistics } from '../../../services/query-v2/products/index/daily-statistics/model'
import {
  BarChartWrapper,
  ColoredCircle,
  ReturnItem,
  ReturnTable,
  ReturnTitle,
  ReturnTitleText,
  ReturnTitles,
  StyledText,
  SymbolWrapper,
  TableText,
} from './styled'
import { getPerformance } from 'pages/index-details/utils'
import { useWindowSize } from 'hooks'
import { getProductByAddress } from 'indices-list'
import { BarChartMobileSelect } from 'components/select'
import { BarChart } from './chart'
import { Weight } from 'components/typography'
import { FlexSpace } from 'components/base'
import { NetworkType } from 'abis/set/sets'
import Big from 'big.js'
import { isAddressEqual } from 'viem'

export enum BarChartTypes {
  MONTH = '1 month',
  THREE_MONTHS = '3 months',
  YTD = 'YTD',
  YEAR = '1 year',
  INCEPTION = 'Inception',
}

export const tableTitles = [
  BarChartTypes.MONTH,
  BarChartTypes.THREE_MONTHS,
  BarChartTypes.YTD,
  BarChartTypes.YEAR,
  BarChartTypes.INCEPTION,
]

export const CustomBarChart: React.FC<{ product: Product; dailyStats: DailyStatistics }> = ({
  product,
  dailyStats,
}) => {
  // FIXME:
  const performance = getPerformance(product, dailyStats)
  const { isMobile } = useWindowSize()
  const [interval, setInterval] = React.useState<BarChartTypes>(BarChartTypes.YTD)
  const selectedIndex = tableTitles.findIndex((el) => el === interval)
  const [highlighted, setHighlighted] = React.useState<string>()
  const productMetaData = getProductByAddress(product.address)
  const { returnBarColour, brandColour, nativeTokenColour, nativeTokenHoverColour } =
    productMetaData

  const barChartColors = [
    {
      backgroundColor: returnBarColour,
      hoverBackgroundColor: brandColour,
    },
    { backgroundColor: nativeTokenColour, hoverBackgroundColor: nativeTokenHoverColour },
  ]

  const productData = {
    label: product.symbol.toUpperCase(),
    data: !isMobile
      ? performance.USD.map((el) => {
          return Big(el).eq(0) ? '0' : el.slice(0, -1)
        })
      : [performance.USD[selectedIndex].slice(0, -1)],
  }

  const data = [
    productData,
    {
      label: product.chainId !== NetworkType.Avalanche ? 'ETH' : 'AVAX',
      data: !isMobile
        ? performance.ETH.map((el) => {
            return Big(el).eq(0) ? '0' : el.slice(0, -1)
          })
        : [performance.ETH[selectedIndex].slice(0, -1)],
    },
  ]

  const leaveChartElement = () => {
    setHighlighted(undefined)
  }

  const hoverChartElement = (el: string) => {
    setHighlighted(el)
  }

  return (
    <BarChartWrapper>
      {isMobile && (
        <BarChartMobileSelect
          list={tableTitles}
          onChange={setInterval}
          borderRadiusStyle={'right'}
        />
      )}
      <BarChart
        highlighted={highlighted}
        setHighlighted={setHighlighted}
        colors={barChartColors}
        chartData={data}
      />
      {!isMobile && (
        <>
          <ReturnTitles>
            {tableTitles.map((el, index) => (
              <ReturnTitle key={`${el}-${index}`}>
                <ReturnTitleText>{el}</ReturnTitleText>
              </ReturnTitle>
            ))}
          </ReturnTitles>
          <ReturnTable>
            {data.map((props, dataIndex) => (
              <ReturnItem
                key={`${props.label}-${dataIndex}`}
                onMouseLeave={leaveChartElement}
                onMouseEnter={() => hoverChartElement(props.label)}
                hoverColor={barChartColors[dataIndex].hoverBackgroundColor}
                active={highlighted === props.label}
              >
                <SymbolWrapper>
                  <ColoredCircle color={barChartColors[dataIndex].backgroundColor} />
                  <StyledText weight={Weight.Regular}>{props.label}</StyledText>
                </SymbolWrapper>
                {props.data.map((el, index) => (
                  <TableText weight={Weight.Regular} key={`${el}-${index}`}>{`${el}%`}</TableText>
                ))}
              </ReturnItem>
            ))}
          </ReturnTable>
        </>
      )}
      {isMobile && (
        <FlexSpace>
          {data.map((props, index) => (
            <ReturnItem
              key={`${props.label}-${index}`}
              onMouseLeave={leaveChartElement}
              onMouseEnter={() => hoverChartElement(props.label)}
              hoverColor={barChartColors[index].hoverBackgroundColor}
              active={highlighted === props.label}
            >
              <SymbolWrapper>
                <ColoredCircle color={barChartColors[index].backgroundColor} />
                <StyledText weight={Weight.Regular}>{props.label}</StyledText>
                {props.data.map((el, index) => (
                  <TableText weight={Weight.Regular} key={`${el}-${index}`}>{`${el}%`}</TableText>
                ))}
              </SymbolWrapper>
            </ReturnItem>
          ))}
        </FlexSpace>
      )}
    </BarChartWrapper>
  )
}
